export default __webpack_public_path__ + "static/media/moe-icon.f394d09e.svg";